import React from 'react';
import { useState } from 'react';

const ExpandText = ({ expandLabel = 'Show More', collapseLabel = 'Show Less', classes = {}, text = '', maxLength = 60 }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <p className={classes.infoText}>
            {isExpanded ? text : `${text.substring(0, maxLength)}${text.length > maxLength ? '...' : ''}`}
            {text.length > maxLength && (
                <span
                    style={{ cursor: 'pointer', marginLeft: 8, fontSize: 12, fontStyle: 'italic' }}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {isExpanded ? collapseLabel : expandLabel}
                </span>
            )}
        </p>
    );
};

export default ExpandText;